import * as React from 'react';
import Styled from 'styled-components';

import { makeThemedButtonCSS } from '../Button/StyledButton';

export interface IButtonLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  variant: 'primary' | 'secondary';
  href: string;
}

const ButtonAsAnchor = Styled.a<IButtonLinkProps>`
  ${props => makeThemedButtonCSS(props.theme.themeTwo, props.variant)}
  text-decoration: none;
`;

const ButtonLink: React.FC<IButtonLinkProps> = ({ href, children, variant, ...rest }) =>
  <ButtonAsAnchor variant={variant} href={href} {...rest}><span>{children}</span></ButtonAsAnchor>;

export default ButtonLink;
